define('viewmodels/header',['plugins/router', 'services/appsecurity', 'services/logger', 'durandal/system', 'services/AppRoutes', 'viewmodels/ChangePassword', 'viewmodels/GeneralSettings', 'viewmodels/configuration/UserRole', 'services/routeconfig', 'durandal/app', 'services/utils', 'viewmodels/UserManual'],
    function (router, appsecurity, logger, system, AppRoutes, ObjChangePassword, ObjGeneralSettings, UserRole, routeconfig, app, utils, UserManual) {
        var viewmodel = {
            setTriggerAttach: true,
            activate: activate,
            logger: logger,
            ObjChangePassword: ObjChangePassword,
            ObjGeneralSettings: ObjGeneralSettings,
            UserRole: UserRole,
            appsecurity: appsecurity,
            AppRoutes: AppRoutes,
            navigatelogin: navigatelogin,
            attached: attached,
            detached: detached,
            UserManual: UserManual,
            ModuleList: ko.observableArray(),
            ClientsCount: ko.observable(),
            SurveyChildLength: ko.observable(),
            AmlRaChildLength: ko.observable(),
            SanctionsRaChildLength: ko.observable(),
            HeatMapsChildLength: ko.observable(),
            ConfigurationChildLength: ko.observable(),
            WTChildLength: ko.observable(),
            GetAssessmentTypeListForUser: GetAssessmentTypeListForUser,
            ShowSettingsContent: ShowSettingsContent,
            ShowUserGroupPopUp: ShowUserGroupPopUp,
            ProfileList: ko.observableArray(),
            LanguageList: ko.observableArray(),
            ProfileofAssessmentList: ko.observableArray([]),
            DocumentTypeList: ko.observableArray(),
            ReportFAQDetailsList: ko.observableArray([]),
            SrNo: ko.observable(),
            utils: utils,
            ShowUserSupport: ShowUserSupport,
            hAssessmentTypeList: ko.observableArray([]),
            lowestOrganizationalLevel: ko.observable("Business Units"),
            GetContactUs: GetContactUs,
            ShowSessionTimer: ShowSessionTimer,
            AssessmentProfSelected: ko.observable(''),
            ProfileList: ko.observableArray([]),
            getProfiles: getProfiles,
            checkUserParams: checkUserParams,
            ExtendUserSessionTime: ExtendUserSessionTime,
            changeClient: changeClient,
            ExpandSubList: ExpandSubList,
            ChangeLocale: ChangeLocale,
            GetLocaleList: GetLocaleList,
            LocalePermissionFlag: ko.observable(false),
            LanguageListApp: ko.observableArray([]),
            IsSSOUser: ko.observable(),

            //SelectedLanguageBadge: ko.observable(''),
            logout: function () {
                var self = this;
                appsecurity.logout()
                    .done(function (token) {
                        $("input[name='__RequestVerificationToken']").val(token);
                        appsecurity.clearAuthInfo();
                        router.navigate('Login');
                        window.location = routeconfig.login;
                        $('#sessionTimer').modal('hide');
                    })
                    .fail(function (error) {
                        appsecurity.clearAuthInfo();
                        router.navigate('Login');
                        window.location = routeconfig.login;
                        $('#sessionTimer').modal('hide');
                    });
            }
        };

        return viewmodel;
        var ViewUserGroupDetailsTableObj = false;

        function activate() {
            try {
                GetAssessmentTypeListForUser();
                viewmodel.appsecurity.GetCurrentLocaleOfUser();
                viewmodel.appsecurity.GetCurrentProfileOfAssessment();
                //viewmodel.appsecurity.GetCurrentLocaleOfUser();
                var url = window.location.href,
                    suburl = url.substring(url.lastIndexOf('/') + 1);

                if (!$("#shellWrapper").hasClass('wrapper') && suburl != "login" && suburl != "Landing#" && suburl != "Landing" && suburl != "") {
                    $("#shellWrapper").addClass('content-wrapper');
                }
                viewmodel.LocalePermissionFlag((viewmodel.appsecurity.PageList() == undefined) ? false : (viewmodel.appsecurity.PageList().indexOf('LocalePermissionFlag') >= 0) ? true : false);
                getLanguagesApp();

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: activate() method in header.js';
                logger.logMessage(msg);
            }
        }

        function attached() {
            try {
                if (viewmodel.ClientsCount() == undefined)
                    viewmodel.ClientsCount(0);

                if (viewmodel.appsecurity.Counter() == undefined)
                    viewmodel.appsecurity.Counter(0);

                StartTimer();
                GetAssessmentTypeListForUser();
              
                viewmodel.ObjGeneralSettings.SetContentWrapper();
                if (appsecurity.EmailId() != undefined && appsecurity.EmailId() != "undefined" && appsecurity.EmailId() != null && appsecurity.EmailId() != "") {
                    GetIsSSOUserFlag();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: attached() method in header.js';
                logger.logMessage(msg);
            }
        }

        function detached() {
            try {
                //$($(document.getElementsByClassName('login-link')).css({ 'display': 'none !important' }));
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: detached() method in header.js';
                logger.logMessage(msg);
            }
        }

        function StartTimer() {

            var x = setInterval(function () {

                // Get todays date and time
                var now = new Date().getTime();

                // Find the distance between now an the count down date
                var distance = new Date(viewmodel.appsecurity.CountDownTime()).getTime() - now;

                // Time calculations for days, hours, minutes and seconds
                var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((distance % (1000 * 60)) / 1000);

                if (hours > 0)
                    // Output the result in an element with id="demo"
                    viewmodel.appsecurity.Timer(hours + "h " + minutes + "m " + seconds + "s ");
                else if (minutes > 0 || seconds > 0)
                    viewmodel.appsecurity.Timer(minutes + "m " + seconds + "s ");
                else if (hours == 0 && minutes == 0 && seconds == 0) {
                    viewmodel.appsecurity.Timer("Session expired");
                }

                if (hours == 0 && minutes < 5 && viewmodel.appsecurity.Counter() == 0) {
                    viewmodel.appsecurity.Counter(viewmodel.appsecurity.Counter() + 1);
                    var url = window.location.href,
                        suburl = url.substring(url.lastIndexOf('/') + 1);
                    
                    if (suburl != "login" && suburl != "" && suburl != "ResetPassword") 
                        $('#sessionTimer').modal('show');

                }

                if (distance < 0) {
                    clearInterval(x);
                    // viewmodel.appsecurity.Time("EXPIRED");
                    viewmodel.logout();
                }
            }, 1000);
        }

        function getLanguagesApp() {
            if (viewmodel.LanguageListApp() == undefined || viewmodel.LanguageListApp().length == 0) {
                getLanguages();
            }
        }

        function GetIsSSOUserFlag() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders()
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Account/GetIsSSOUserFlag",
                    type: "POST",
                    headers: headers,
                    data: { Email: appsecurity.EmailId() }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + 'Source: ajaxCall in GetIsSSOUserFlag() in header.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        viewmodel.IsSSOUser(jsonResult);
                        appsecurity.IsSSOUserFlag(jsonResult);
                    }
                }
                catch (e) {
                    var msg = 'Exception:' + e + '| Source : ajaxSuccess of GetIsSSOUserFlag() in header.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                // ajaxFail code
            }
        }

        function getLanguages() {
            try {

                $.ajax({
                    url: "/api/Account/GetLanguages",
                    type: "GET",
                    //async: false,
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + 'Source: ajaxCall in GetLanguages() in GeneralSettings.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult.length > 0) {
                            var mappedLanguages = $.map(jsonResult, function (result) {
                                return new GetLanguagesModel(result);
                            });
                            viewmodel.LanguageListApp(mappedLanguages);
                        }
                    }
                catch (e) {
                    var msg = 'Exception:' + e + '|Source : ajaxSuccess of GetLanguages() in GeneralSettings.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetLanguages() in GeneralSettings.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in  GetLanguages() in GeneralSettings.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetLanguagesModel(item) {
            try {
                var self = this;
                self.LANGUAGE_ID = ko.observable(item.LANGUAGE_ID);
                self.LANGUAGENAME = ko.observable(item.LANGUAGENAME);
                self.LOCALE = ko.observable(item.LOCALE);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetLanguagesModel() method in GeneralSettings.js';
                logger.logMessage(msg);
            }
        }

        function changeClient() {
            try {
                //app.showMessage('Are you sure you want to Switch the Client?', 'Switch Client', [' Cancel', ' Confirm'])
                //    .then(function (option) {
                //        if (option === ' Confirm') {
                //            if (viewmodel.ProfileList() != undefined) {
                //                viewmodel.ProfileList([]);
                //            }
                //            router.navigate('ProjectLanding');
                //        }
                //    });

                var text = (viewmodel.ObjGeneralSettings.LocalizedIndexList.indexOf('AreSwitchClient') == -1) ? 'Are you sure you want to Switch the Client' : viewmodel.ObjGeneralSettings.LocalizedTextList()[viewmodel.ObjGeneralSettings.LocalizedIndexList.indexOf('AreSwitchClient')].Name();
                var clientSwitch = (viewmodel.ObjGeneralSettings.LocalizedIndexList.indexOf('SwitchClient') == -1) ? 'Switch Client' : viewmodel.ObjGeneralSettings.LocalizedTextList()[viewmodel.ObjGeneralSettings.LocalizedIndexList.indexOf('SwitchClient')].Name();

                app.showMessage(text + '?', clientSwitch, [(viewmodel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton') == -1) ? 'Cancel' : viewmodel.ObjGeneralSettings.LocalizedTextList()[viewmodel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton')].Name, (viewmodel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : viewmodel.ObjGeneralSettings.LocalizedTextList()[viewmodel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name])
                    .then(function (option) {
                        var confirmText = ((viewmodel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? 'Confirm' : viewmodel.ObjGeneralSettings.LocalizedTextList()[viewmodel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name()).toString();
                        if (option === confirmText) {
                            if (viewmodel.ProfileList() != undefined) {
                                viewmodel.ProfileList([]);
                            }
                            router.navigate('ProjectLanding');
                        }
                    });

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call from changeClient() method in GeneralSettings.js';
                logger.logMessage(msg);
            }
        }

        function GetLocaleList() {
            try {
                if (viewmodel.LanguageList() == undefined || viewmodel.LanguageList().length == 0) {
                    if (viewmodel.ObjGeneralSettings.LanguageList() == undefined || viewmodel.ObjGeneralSettings.LanguageList().length == 0) {
                        viewmodel.ObjGeneralSettings.getLanguages();
                    }
                    viewmodel.LanguageList(viewmodel.ObjGeneralSettings.LanguageList());
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call from GetLocaleList() method in GeneralSettings.js';
                logger.logMessage(msg);
            }
        }
        function ChangeLocale(localeId, localeText) {
            try {
                var url = window.location.href,
                    surl = url.substring(url.lastIndexOf('/') + 1);
                if (viewmodel.appsecurity.WriteAccess() && (surl == 'SurveyResponsePage' || surl == 'SurveyResponsePage#')) {

                    app.showMessage((viewmodel.ObjGeneralSettings.LocalizedIndexList.indexOf('DirtyDataCheckSurveyPage') == -1) ? 'Please click the save button on page below before moving out of this Survey, otherwise the changes made will be lost.' : viewmodel.ObjGeneralSettings.LocalizedTextList()[viewmodel.ObjGeneralSettings.LocalizedIndexList.indexOf('DirtyDataCheckSurveyPage')].Name, "Warning", [(viewmodel.ObjGeneralSettings.LocalizedIndexList.indexOf('CloseSaveButton') == -1) ? ' Stay on survey and save' : viewmodel.ObjGeneralSettings.LocalizedTextList()[viewmodel.ObjGeneralSettings.LocalizedIndexList.indexOf('CloseSaveButton')].Name, (viewmodel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton') == -1) ? 'Cancel' : viewmodel.ObjGeneralSettings.LocalizedTextList()[viewmodel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton')].Name], true, { buttonClass: "fa fa-check btn", primaryButtonClass: "primary-btn", popupIcon: 'title-icon col-md-1 fa fa-warning' })
                        .then(function (option) {
                            if (option == ((viewmodel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton') == -1) ? 'Cancel' : viewmodel.ObjGeneralSettings.LocalizedTextList()[viewmodel.ObjGeneralSettings.LocalizedIndexList.indexOf('CancelButton')].Name)()) {
                                ChangeLocaleMain(localeId, localeText);
                            }
                            else {
                                //viewmodel.DashboardVM.NavigatedFrom('Response');
                                return false;
                            }
                        })
                } else {
                    ChangeLocaleMain(localeId, localeText);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call from ChangeLocale() method in header.js';
                logger.logMessage(msg);
            }
        }

        function ChangeLocaleMain(localeId, localeText) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Account/SaveLocaleSettings?localeId=" + localeId,
                    type: "POST",
                    headers: headers,
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call from SaveSettings() method in GeneralSettings.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                        logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(viewmodel), true);
                    }
                    else {
                        if (status == 'success') {
                            viewmodel.appsecurity.CurrentLocaletextOfUser(localeText);
                            appsecurity.CurrentLocaleOfUser(localeId);
                            viewmodel.appsecurity.CurrentLocaleOfUserFromLoginId(localeId);

                            logger.logSuccess('Language changed successfully.', 'Success', system.getModuleId(viewmodel), true);

                            var url = window.location.href,
                                suburl = url.substring(url.lastIndexOf('/') + 1);

                            if (suburl == 'Landing' || suburl == 'Landing#') {
                                //location.reload(true);
                                viewmodel.ObjGeneralSettings.GetLocalizedData();
                            }
                            else {
                                router.navigate('Landing', true);
                                location.reload(true);
                            }
                        }
                        else {
                            logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(viewmodel), true);
                        }
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxSuccess method in SaveSttings() method in GeneralSettings.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    var msg = 'Exception: ' + error + ' | Source:ajaxFail method in SaveSttings() method in GeneralSettings.js';
                    logger.logMessage(msg);

                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxFail method in SaveSttings() method in GeneralSettings.js';
                    logger.logMessage(msg);
                }
            }
        }

        function getProfiles() {
            try {
                //if (viewmodel.ProfileList() == undefined || viewmodel.ProfileList().length == 0) {
                $.ajax({
                    url: "/api/Account/GetProfiles",
                    type: "GET",
                    async: false,
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
                //}
            }
            catch (e) {
                var msg = 'Exception' + e + 'Source: ajaxCall in GetProfiles() in GeneralSettings.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult.length > 0) {
                        if (jsonResult[0].ErrorId == -99) {
                            logger.logError(jsonResult[0].ErrorCode + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(viewmodel), true);
                        }
                        else {
                            viewmodel.ProfileList([]);
                            var mappedProfiles = $.map(jsonResult, function (result) {
                                return new ProfileListModel(result);
                            });
                            viewmodel.ProfileList(mappedProfiles);
                        }
                    }
                    else {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(viewmodel), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception:' + e + '|Source : ajaxSuccess of GetProfiles() in GeneralSettings.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetProfiles() in GeneralSettings.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in  GetProfiles() in GeneralSettings.js';
                    logger.logMessage(msg);
                }
            }

        }

        function checkUserParams() {
            try {
              
                if (viewmodel.ClientsCount() == undefined || viewmodel.ClientsCount() == 0) {
                    $.ajax({
                        url: "/api/Account/GetProjectsList",
                        type: "GET",
                        headers: appsecurity.getSecurityHeaders(),
                        global: false
                    })
                        .success(ajaxSuccess)
                        .fail(ajaxFail);
                }
            }
            catch (e) {
                var msg = 'Exception' + e + 'Source: ajaxCall in checkUserParams() in GeneralSettings.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult.length > 0) {
                        if (jsonResult[0].ErrorId == -99) {
                            logger.logError(jsonResult[0].ErrorCode + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(viewmodel), true);
                        }
                        else {
                            viewmodel.ClientsCount(jsonResult.length);
                        }
                    }
                    else {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(viewmodel), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception:' + e + '|Source : ajaxSuccess of checkUserParams() in GeneralSettings.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in checkUserParams() in GeneralSettings.js';
                    logger.logMessage(msg);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in  checkUserParams() in GeneralSettings.js';
                    logger.logMessage(msg);
                }
            }

        }

        function ProfileListModel(item) {
            try {
                var self = this;
                self.ProfileId = ko.observable(item.ID);
                self.ProfileName = ko.observable(item.PROFILE_NAME);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ProfileListModel() method in HeatMap.js';
                logger.logMessage(msg);
            }
        }

        function navigatelogin() {

            try {
                if (window.location.href.indexOf('?returnUrl') > 0)
                    router.navigate("login?" + window.location.href.split('?')[1], true);
                else
                    router.navigate("login", true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: navigatelogin() method in header.js';
                logger.logMessage(msg);
            }
        }

        function ShowUserSupport() {
            try {
                appsecurity.UserContent('faqList');
                router.navigate('UserManual');
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowUserSupport() method in header.js';
                logger.logMessage(msg);
            }
        }

        function GetContactUs() {
            try {
                if (viewmodel.appsecurity != undefined && viewmodel.appsecurity.userInfo() != undefined) {
                    if (viewmodel.appsecurity.ContanctUs() == undefined || viewmodel.appsecurity.ContanctUs() == '') {
                        GetContactUsInformation();
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetContactUs() method in header.js';
                logger.logMessage(msg);
            }
        }

        function GetContactUsInformation() {
            try {
                var headers = appsecurity.getSecurityHeaders();
                return $.ajax({
                    url: "/api/Configuration/GetUserSupportList",
                    type: "GET",
                    headers: headers,
                    //data: { TypeId: 14 },//14 is the id for contact us data}
                    global: false
                })
                    .success(function (jsonResult, error) {

                        if (jsonResult.length == 0)
                            logger.logError('No data available for Contact us.', 'Warning', system.getModuleId(viewmodel), true);

                        viewmodel.appsecurity.ContanctUs('No contact information available.');
                        var MappedContactUs = $.map(jsonResult, function (result) {
                            if (result.Identifier === 'ContactUs')
                                return new UserSupportModel(result);
                        });

                        viewmodel.appsecurity.ContanctUs(MappedContactUs[0].Description());
                        //if (jsonResult.length != 0) {
                        //    if (jsonResult.Description != null && jsonResult.Description != undefined)
                        //        viewmodel.appsecurity.ContanctUs(ko.observable($('<div/>').html(jsonResult.Description).text()));
                        //}

                    })
                    .fail(function (error, status) {
                        logger.logError('An error has occurred while fetching the User support. Please contact your Administrator.', 'Error', system.getModuleId(viewmodel), true);
                    })
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetContactInformation() method in header.js';
                logger.logMessage(msg);
            }
        }

        function UserSupportModel(item) {
            try {
                var self = this;
                self.ID = ko.observable(item.ID);
                //self.Description = ko.observable($('<div/>').html(item.Description).text());
                self.Description = ko.observable(item.Description);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: UserSupportModel() method in header.js';
                logger.logMessage(msg);
            }
        }

        function ShowSessionTimer() {
            try {
                $('#sessionTimer').modal('show');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowSessionTimer() method in header.js';
                logger.logMessage(msg);
            }
        }

        function ExtendUserSessionTime() {
            try {
                viewmodel.appsecurity.RefreshTokenSession();
                $('#sessionTimer').modal('hide');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ExtendUserSessionTime() method in header.js';
                logger.logMessage(msg);
            }
        }

        function ShowSettingsContent() {
            try {

                $('#changepassworddiv').show();
                $('#SubmitoptionBtn').hide();
                $('#SubmitOTPBtn').hide();
                $('#changepasswordbtn').show();

                $('#validateOTPButton').hide();
                $('#Authenticatebutton').hide();
                $('#submitbutton').show();

                appsecurity.UserContent('changePhone-Pwd');
                if (window.location.href.indexOf("UserManual") > -1) {
                    viewmodel.UserManual.ShowGeneralManual('changePhone-Pwd');
                    $("#Numberphonenumberchange").intlTelInput({
                        allowExtensions: true,
                        autoFormat: false,
                        autoHideDialCode: false,
                        autoPlaceholder: false,
                        defaultCountry: "auto",
                        ipinfoToken: "yolo",
                        nationalMode: false,
                        numberType: "MOBILE",
                        preventInvalidNumbers: true,
                    });
                }
                else
                    router.navigate('UserManual');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowSettingsContent() method in header.js';
                logger.logMessage(msg);
            }
        }

        function ShowUserGroupPopUp() {
            try {
                ViewUserGroupDetailsTableObj.clear().destroy();
                $('#ViewUserGroupDetailsTable tbody tr').remove();
                UserRole.viewUserGroupDetails().then(function () {
                    ViewUserGroupDetailsTableObj = undefined;
                    ViewUserGroupDetailsTableObj = $('#ViewUserGroupDetailsTable').DataTable({});
                    $('#frmViewUserGroupDetails').modal('show');
                })

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowUserGroupPopUp() method in header.js';
                logger.logMessage(msg);
            }
        }

        function GetAssessmentTypeListForUser() {
            var self = this;
            try {
                return $.ajax({
                    url: "/api/Account/GetAssessmentTypeListForUser",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                }).success(function (result) {
                    if (result != null && result.length > 0) {
                        viewmodel.hAssessmentTypeList([]);

                        var mappedassessments = $.map(result, function (item) {
                            return new headerAssessmentmodel(item)
                        })
                        viewmodel.hAssessmentTypeList(mappedassessments);
                    }
                    else {
                        //viewmodel.hAssessmentTypeList([{ name: 'AML', id: 1 }, { name: 'SANC', id: 2 }, { name: 'OFAC', id: 3 }]);
                    }
                }).fail(function () {
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call from GetAssessmentTypeListForUser() method in header.js';
            }
        }

        function ExpandSubList(list, image) {
            try {
                var img = document.getElementById(image);
                var ele = document.getElementById(list);
                $(".treeview-menu").hide();
                var count = document.querySelectorAll("#" + list + " li").length;    //Count of li elements in the ul
                if (count > 0) {
                    if (ele.style.display == "block") {
                        ele.style.display = "none";
                        img.classList.remove("fa-angle-down");
                        img.classList.add("fa-angle-left");
                    }
                    else {
                        img.classList.remove("fa-angle-left");
                        img.classList.add("fa-angle-down");
                        ele.style.display = "block";
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in ExpandSubList() method in header.js';
                logger.logMessage(msg);
            }
        }

        //Model defintions starts here
        function ProfileofAssessmentModel(item) {
            try {
                var self = this;
                self.ConfigurationFreezeFlag = ko.observable('true');
                self.Fromdate = ko.observable($('<div/>').html(item.Fromdate).text());
                self.Todate = ko.observable($('<div/>').html(item.Todate).text());
                self.ProfileId = ko.observable($('<div/>').html(item.ProfileId).text());
                self.Profilename = ko.observable($('<div/>').html(item.Profilename).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ProfileofAssessmentModel() method in header.js';
                logger.logMessage(msg);
            }
        }

        function headerAssessmentmodel(item) {
            try {
                var self = this;
                self.name = item.ASSESSMENT_TYPE;
                self.id = item.ID;
                self.asstype = item.CONFIGURATION_TYPE;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:headerAssessmentmodel() method in header.js';
            }
        }

    });

